import { ApplicationSDKState } from 'sdk/interfaces/sdkInterface';
import { sliceName } from './firebaseConfig';

export const sliceSelector = (state: ApplicationSDKState) => {
    return state[sliceName];
};